export default "__VITE_ASSET__BnbhNdJa__"